<template>
  <User v-if="hasId" />
  <div v-else>
    <form>
      <div class="columns padding-bottom20">
        <div class="col-4 column">
          <InputText v-model="filter.text" placeholder="Naziv, e-naslov, naročnik, dš, matična" />
        </div>
        <div class="col-2 column">
          <button class="button" @click.prevent="getData(null, true)">Išči</button>
        </div>
      </div>
    </form>
    <div class="padding-bottom10 text-right">
      <a href @click.prevent="toXls">Izvoz v excel</a>
    </div>
    <Tables :columns="cols" :outerPageNumber="filter.pagerPage" :data="data" @page-filter-change="getData($event)" :searchEnabled="false" />
  </div>
</template>

<script lang="ts">
import User from '@/components/User.vue'
import Tables from '@/components/common/TablesDb.vue'
import InputText from '@/components/common/InputText.vue'
import { useApi } from '@/lib/api'
import { defineComponent, ref, computed, watch, markRaw } from 'vue'
import { useRoute } from 'vue-router'
import { downloadStream } from '@/lib/common'
import { useStore } from 'vuex'

const userType = markRaw({
  template: `<span>{{data.b2b === true ? 'B2B':'Spletni'}}</span>`,
  props: {
    data: {}
  }
})

export default defineComponent({
  components: { Tables, InputText, User },
  setup() {
    const _store = useStore()
    const _api = useApi()
    const _route = useRoute()
    const cols = ref([
      { field: 'id', caption: '#', dbField: 'id', hidden: true },
      { field: 'userAdmin', caption: 'Administrator', dbField: 'uporadmin' },
      { field: 'idUser', caption: 'ID uporabnika', dbField: 'id_user' },
      { field: 'user', caption: 'Uporabnik', dbField: 'upor' },
      { field: 'b2b', caption: 'Tip uporabnika', dbField: 'A.b2b', component: userType },
      { field: 'active', caption: 'Aktivnost uporabnika', dbField: 'U.aktiven', format: { type: 'yesno' } },
      { field: 'admin', caption: 'Pravica admin', dbField: 'U.admin', format: { type: 'yesno' } },
      { field: 'superAdmin', caption: 'Pravica superadmin', dbField: 'U.superadmin', format: { type: 'yesno' } },
      { field: 'date', caption: 'Datum', format: { type: 'date', format: 'DD.MM.YYYY HH:mm' }, dbField: 'A.date_create' }
    ])
    const data = ref([])
    const filter = ref({ pagerPage: 1, pagerPageSize: 20, pagerSort: 'A.id desc' })
    const hasId = computed(() => _route.params.id)

    const getData = async (e?: any, f?: any) => {
      if (!hasId.value) {
        if (e) {
          filter.value.pagerPage = e.page
          filter.value.pagerSort = e.sort ? e.sort : 'A.id desc'
        } else if (filter.value.pagerPage > 1) {
          if (f) {
            filter.value.pagerPage = 1
          }
          return
        }
        const res = await _api.post<any>('adminRevisionList', filter.value, true)
        data.value = res.data
      }
    }

    const toXls = async () => {
      _store.commit('appLoading', true)
      try {
        const res = await _api.axios.post<any>('adminRevisionList?export=true', filter.value, { responseType: 'blob' })
        if (res.status === 200) {
          downloadStream(res.data, 'Revizijska_sled.xlsx')
        }
      } finally {
        _store.commit('appLoading', false)
      }
    }

    watch(hasId, () => getData())

    getData()

    return { cols, data, filter, getData, hasId, toXls }
  }
})
</script>

<style lang="scss" scoped>
.submenu {
  list-style: none;
  margin: -10px 0 20px 0;

  li {
    display: inline-block;
    padding-right: 20px;
    border-right: solid 1px #474747;

    &:last-child {
      border-right: none;
    }
  }
}
</style>
